export enum FolderWatchMethod {
  Off = 0,
  FileWatcher = 1,
  Polling = 2,
  Trial = 3,
  Failed = 4,
}
